module.exports = __webpack_public_path__ + "static/media/19ESCAP37.55d7dc29.jpg";